import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Cta from "../components/cta"
import Face from "../images/face.svg"
import Enable from "../images/enable.svg"
import Chart from "../images/chart.svg"
import Likert from "../images/likert.svg"
import Check from "../images/check.svg"
import Tick from "../images/tick.svg"
import Circle from "../images/circle.svg"

const IndexPage = () => (
  <Layout>
    <Seo 
		title="Performance Management software" 
		description="Employee performance review and 1:1 human resources software with powerful aggregated employee and team data designed to improve company outcomes."
	/>
		<div className="container">
			<div className="row">
				<div className="hero-home">
					<div className="hero-home-text">
						{/* <span 
							className="highlight"
							data-sal="slide-up" 
							data-sal-easing="ease"
							data-sal-delay="100"
							data-sal-duration="300">
								Dramatically
						</span> */}
						<h1 data-sal="slide-up" 
							data-sal-easing="ease"
							data-sal-delay="300"
							data-sal-duration="400">Improve your team reviews and 1:1's</h1>
						<p className="lead"
							data-sal="slide-up" 
							data-sal-easing="ease"
							data-sal-delay="400"
							data-sal-duration="400"
						>Create, manage and get deeper insights on your employee reviews, 1:1's and aggregated team performance with Enabli.</p>
						<Link to="/contact" className="btn btn-lg btn-blue"
							data-sal="slide-up" 
							data-sal-easing="ease"
							data-sal-delay="500"
							data-sal-duration="400"
						>Request a demo</Link>
					</div>
					<div className="hero-home-img-wrapper">
						<StaticImage
							src="../images/hr-manager.png"
							formats={["AUTO", "WEBP", "AVIF"]}
							placeholder="none"
							className="hero-home-img"
							backgroundcolor="white"
							layout="fullWidth"
							quality="100%"
							alt="HR Manager at a laptop"
						/>
						<div className="face">
							<img src={Face} alt="icon from a likert scale with a smiley face" />
						</div>
						<div className="enable">
							<img src={Enable} alt="icon from an enablement suggestion question" />
						</div>
						<div className="likert">
							<img src={Likert} alt="icon from a likert scale HR question" />
						</div>
						<div className="chart">
							<img src={Chart} alt="chart showing KPI Management performance" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<section className="section-pad-bottom" id="features">
			<div className="container-lg">
				<div className="row">
					<div className="feature-bg blue">
						<div className="container">
							<div className="row">
								<div className="feature">
									<div className="feature-img-wrapper">		
										<StaticImage
											src="../images/enabli-charts.png"
											formats={["AUTO", "WEBP", "AVIF"]}
											placeholder="none"
											backgroundcolor="white"
											className="feature-img"
											layout="fullWidth"
											quality="100%"
											alt="laptop with the Enabli team performance charts dashboard"
										/>
										<div className="circle">
											<img src={Circle} alt="circle for decoration" />
										</div>
									</div>
									<div className="feature-text">
										{/* <span className="highlight"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="100"
											data-sal-duration="300"
										>Deep insights</span> */}
										<h2
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="300"
											data-sal-duration="400"
										>Aggregate team review data</h2>
										<p className="lead"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="400"
											data-sal-duration="400"
										>Enabli is a data driven employee review tool that gives executives and management a clear view of performance data for each employee as well as the collective performance of teams.</p>
										<ul className="list-unstyled feature-list"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="500"
											data-sal-duration="400"
										>
											<li><img src={Check} alt="check icon" />Aggregate team review data</li>
											<li><img src={Check} alt="check icon" />Historical employee review data</li>
											<li><img src={Check} alt="check icon" />Compare past and present reviews &amp; planned outcomes</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div className="container-lg">
				<div className="row">
					<div className="feature-bg">
						<div className="container">
							<div className="row">
								<div className="feature feature-mid">
									<div className="feature-text">
										{/* <span className="highlight"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="100"
											data-sal-duration="300"
										>Flexible</span> */}
										<h3
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="300"
											data-sal-duration="400"
										>Create and tailor your reviews rapidly</h3>
										<p className="lead"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="400"
											data-sal-duration="400"
										>Creating review questionaires just became easy. Use our library of likert scale and enablement suggestion questions or add your own.</p>
										<ul className="list-unstyled feature-list"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="500"
											data-sal-duration="400"
										>
											<li><img src={Check} alt="check icon" />Company-wide library of review questions</li>
											<li><img src={Check} alt="check icon" />Use our likert scale questions, or add your own</li>
											<li><img src={Check} alt="check icon" />Add text-input and multiple choice enablement questions</li>
										</ul>
									</div>
									<div className="feature-img-wrapper">		
										<StaticImage
											src="../images/enabli-question-library.png"
											formats={["AUTO", "WEBP", "AVIF"]}
											placeholder="none"
											backgroundcolor="white"
											className="feature-img"
											layout="fullWidth"
											quality="100%"
											alt="laptop showing the enabli review question library"
										/>
										<div className="circle-mid">
											<img src={Circle} alt="circle for decoration" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section className="section-pad">
			<div className="container-lg">
				<div className="row">
					<div className="feature-bg purple">
						<div className="container">
							<div className="row">
								<div className="feature">
									<div className="feature-img-wrapper">		
										<StaticImage
											src="../images/enabli-employee-reviews.png"
											formats={["AUTO", "WEBP", "AVIF"]}
											placeholder="none"
											backgroundcolor="white"
											className="feature-img"
											layout="fullWidth"
											quality="100%"
											alt="laptop showing the enabli employee reviews screen"
										/>
										<div className="circle">
											<img src={Circle} alt="circle for decoration" />
										</div>
									</div>
									<div className="feature-text">
										{/* <span className="highlight"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="100"
											data-sal-duration="300"
										>Powerful</span> */}
										<h3
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="300"
											data-sal-duration="400"
										>View all performance metrics</h3>
										<p className="lead"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="400"
											data-sal-duration="400"
										>All of your company performance data in one easy-to-use dashboard.</p>
										<ul className="list-unstyled feature-list"
											data-sal="slide-up" 
											data-sal-easing="ease"
											data-sal-delay="500"
											data-sal-duration="400"
										>
											<li><img src={Check} alt="check icon" />View employee goals</li>
											<li><img src={Check} alt="check icon" />See who read company announcements</li>
											<li><img src={Check} alt="check icon" />View all performance review data and 1:1 notes</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section id="pricing" className="section-pad-bottom">
			<div className="container">
				<div className="row">
					<div className="text-center">
						<h4 className="price-section-title">Pricing</h4>
					</div>
					<div className="pricing-row">
						<div className="pricing-tier">
							<span className="tier-title">Small to Mid Market</span>
							<span className="price">$60</span>
							<span className="price-duration">per user / month, billed annually</span>
							<ul className="list-unstyled price-list">
								<li><img src={Tick} alt="check icon" />Up to 50 users </li>
								<li><img src={Tick} alt="check icon" />Access all features </li>
								<li><img src={Tick} alt="check icon" />Dedicated Account Manager </li>
								<li><img src={Tick} alt="check icon" />Unlimited platform training </li>
							</ul>
							<Link to="/contact" className="btn btn-lg btn-blue btn-block"
								data-sal="slide-up" 
								data-sal-easing="ease"
								data-sal-delay="100"
								data-sal-duration="400"
							>Request demo</Link>
						</div>
						<div className="pricing-tier">
							<span className="tier-title">Large</span>
							<span className="price">$50</span>
							<span className="price-duration">per user / month, billed annually</span>
							<ul className="list-unstyled price-list">
								<li><img src={Tick} alt="check icon" />50 - 200 users </li>
								<li><img src={Tick} alt="check icon" />Access all features </li>
								<li><img src={Tick} alt="check icon" />Dedicated Account Manager </li>
								<li><img src={Tick} alt="check icon" />Unlimited platform training </li>
							</ul>
							<Link to="/contact" className="btn btn-lg btn-blue btn-block"
								data-sal="slide-up" 
								data-sal-easing="ease"
								data-sal-delay="200"
								data-sal-duration="400"
							>Request demo</Link>
						</div>
						<div className="pricing-tier">
							<span className="tier-title">Enterprise</span>
							<span className="price">Enquire</span>
							<span className="price-duration">for pricing</span>
							<ul className="list-unstyled price-list">
								<li><img src={Tick} alt="check icon" />200+ users </li>
								<li><img src={Tick} alt="check icon" />Access all features </li>
								<li><img src={Tick} alt="check icon" />Dedicated Account Manager </li>
								<li><img src={Tick} alt="check icon" />Unlimited platform training </li>
							</ul>
							<Link to="/contact" className="btn btn-lg btn-line btn-block"
								data-sal="slide-up" 
								data-sal-easing="ease"
								data-sal-delay="300"
								data-sal-duration="400"
							>Contact sales</Link>
						</div>
					</div>
					<p className="text-center below-price-table">Have questions? Find out more on our <Link to="/faqs">FAQs</Link> page or <Link to="/contact">contact us</Link>. All prices are in US Dollars.</p>
				</div>
			</div>
		</section>

		<Cta />

  </Layout>
)

export default IndexPage
